export default __webpack_public_path__ + "static/media/Youtube_Channel_Art.9836dda9.png";